import * as React from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import { useDashboard } from '../DashboardProvider'
import { Button, Card, Typography } from '~/components/_atoms'
import { Stack } from '~/components/_layouts'
import YnsIcon from '../../icons/YnsIcon'

export function MyJobsCard({ className }) {
  const { t } = useTranslation()
  const { current_user } = useDashboard()
  const hasAppliedJobs = current_user.recently_applied_job_count > 0
  const hasSavedJobs = current_user.my_jobs_count > 0

  if (hasAppliedJobs || hasSavedJobs) {
    return (
      <Card
        className={className}
        title={t('my_jobs_card.title')}
        icon={<YnsIcon name="job-targeting" className="h-10 w-10" />}
        actions={
          <Button
            variant="outline"
            href="job-search/saved_jobs"
            className="ga-trackable w-full @md:w-auto"
          >
            {t('my_jobs_card.action_text')}
          </Button>
        }
      >
        <Stack spacing={2}>
          <Typography>{t('my_jobs_card.description')}</Typography>
          <div className="max-w-90 flex items-center justify-between gap-3">
            <Typography className="flex-2 font-bold">
              {t('my_jobs_card.my_jobs')}
            </Typography>
            <Typography
              variant="subtitle"
              className="flex-1 text-right font-bold"
            >
              {current_user.my_jobs_count}
            </Typography>
          </div>
          <div className="max-w-90 flex items-center justify-between gap-3">
            <Typography className="flex-2 font-bold">
              {t('my_jobs_card.jobs_applied')}
            </Typography>
            <Typography
              variant="subtitle"
              className="flex-1 text-right font-bold"
            >
              {current_user.recently_applied_job_count}
            </Typography>
          </div>
        </Stack>
      </Card>
    )
  }

  return (
    <Card
      className={className}
      title={t('my_jobs_card.empty.title')}
      icon={<YnsIcon name="job-targeting" className="h-10 w-10" />}
      actions={
        <div className="flex w-full flex-col gap-2 @md:flex-row">
          <Button
            variant="ghost"
            href="/job-search/jobs"
            className="ga-trackable w-full @md:w-auto"
          >
            {t('my_jobs_card.empty.action_search')}
          </Button>
          <Button
            variant="ghost"
            href="/job-search/boards"
            className="ga-trackable w-full @md:w-auto"
          >
            {t('my_jobs_card.empty.action_job_board')}
          </Button>
        </div>
      }
    >
      <Stack spacing={2}>
        <Typography>{t('my_jobs_card.empty.description')}</Typography>
      </Stack>
    </Card>
  )
}
